module.exports = __webpack_public_path__ + "9e6830cf349fbbe2c4c40caae8d42c10.svg";